<template>
    <div id="view-report">
        <div class="content" v-if="detail">
            <a-dropdown :trigger="['click']">
                <a-menu slot="overlay"  @click="handleMenuClick">
                    <a-menu-item key="release" disabled>定稿</a-menu-item>
                    <a-menu-item key="share">分享</a-menu-item>
                    <a-menu-item key="download">下载</a-menu-item>
                    <a-menu-item key="delete" disabled>删除</a-menu-item>
                </a-menu>
                <a-button class="more-icon" style="margin-left: 8px">
                    <a-icon class="f20" type="ellipsis" />
                </a-button>
            </a-dropdown>
            <h1 class="header">{{detail.reportName}}</h1>
            <p class="user-info f16">
                <span>{{detail.name}}</span>
                <span>{{detail.timePoint}}</span>
                <span>{{detail.city}}</span>
            </p>
            <template v-if="detail.modules && detail.modules.length">
                <div 
                    v-for="(group,groupIndex) in detail.modules"
                    :key="groupIndex"
                >
                    <h2 class="f18">{{title[groupIndex]+"、"+group.moduleName}}</h2>
                    <template v-if="group.modules && group.modules.length">
                        <div
                            v-for="(secGroup,secGroupIndex) in group.modules"
                            :key="secGroupIndex"
                        >
                            <p class="f16" style="margin-left:20px;">{{secGroupIndex+1+"、"+secGroup.moduleName}}</p>
                            <template v-if="secGroup.modules && secGroup.modules.length">
                                <div
                                    v-for="(item,index) in secGroup.modules"
                                    :key="index"
                                >
                                    <p class="description f16" v-if="!index">{{item.description}}</p>
                                    <p class="description f16">
                                        图
                                        {{index+1}}
                                        是
                                        {{item.imageDate}}
                                        {{item.imageCity}}
                                        {{item.subModule}}
                                    </p>
                                    <template v-if="item.contents && item.contents.length">
                                        <p 
                                            v-for="child in item.contents"
                                            :key="child.id"
                                            class="description f16"
                                        >
                                            <span>{{child.content}}</span>
                                        </p>
                                    </template>
                                    <img class="img" :src="item.imageUrl  | imgUrl(2)" />
                                    <p class="img-description">
                                        图
                                        {{index+1}}
                                        {{item.imageCity}}
                                        {{item.subModule}}
                                    </p>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
            <div style="padding:20px 0">
                <h2>总结：</h2>
                <p class="description" v-if="detail.summary">
                    <span>{{detail.summary}}</span>
                </p>
            </div>
        </div>
        <a-modal 
            title="分享报告" 
            v-model="showModel"
            :maskClosable="false"
            @ok="onModalOK"
            okText="复制链接"
        >
            <a-textarea
                ref="textArea"
                class="disabled"
                :autosize="{ minRows: 3, maxRows: 6 }"
                v-model="modelValue"
            />
        </a-modal>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"ViewReport",
    data () {
        return {
            title:["一","二","三","四","五","六","七","八","九","十","十一","十二","十三","十四","十五","十六","十七","十八","十九","二十"],
            reportId: null,
            detail: null,
            modelValue:"",
            showModel:false
        };
    },
    created(){
        if(!this.$route.query.id){
            this.$router.push("/report-list/answer");
            return;
        }
        this.reportId = this.$route.query.id;
        this.getReportDetail();
    },
    methods: {
        onModalOK(){
            this.$refs.textArea.$el.select();
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.modelValue = null;
            this.showModel = false;
            this.$message.success("复制链接成功");
        },
        //  更多列表中选择
        handleMenuClick(val){
            if(val.key === "share"){
                this.shareReport();
            }else if(val.key==="download"){
                this.shareReport();
            }
        },
        // 分享解读报告
        shareReport(){
            let url = UrlApi.shareReport;
            let token = this.$store.getters.getToken;
            this.$http.get(url,{
                params:{
                    reportId: this.reportId
                },
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.$message.success(message);
                    this.showShareModal(res.data.data)
                }else {
                    this.$message.warning(message);
                }
            })
        },
        // 显示分享弹窗
        showShareModal(url){
            this.showModel = true;
            this.modelValue = url;
        },
        // 获取报告详情
        getReportDetail(){
            let url = UrlApi.reportDetail;
            let token = this.$store.getters.getToken;
            this.$http.get(url,{
                params:{
                    reportId: this.reportId
                },
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                if(res.data.success){
                    this.detail = res.data.data;
                }else {
                    this.$message.warning(res.data.message);
                }
            })
        }
    }
}

</script>
<style lang="less" scoped>
    .disabled {
        pointer-events: none;
        resize: none;
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
    }
    #view-report {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
        height: auto;
        padding: 30px;
        .content {
            height: 100%;
            background-color: #ffffff;
            padding: 20px 150px 0 150px;
            height: auto;
            min-height: calc(100vh - 205px);
            position: relative;
            left: 0;
            top: 0;
            .header {
                // text-align: center;
                margin-left: 30%;
            }
            .user-info {
                color:#9B9B9B;
                & > span {
                    margin-right: 10px;
                }
            }
            .description {
                margin-left: 60px;
            }
            .img {
                width: 600px;
                margin-left: 100px;
            }
            .img-description {
                margin: 20px 0 20px 250px;
            }
            .more-icon {
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                position: fixed;
                top: calc(100vh - 400px);
                right: 140px;
            }
        }
    }
</style>